import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_BASE_URL || "https://primebank.com.np/pr1me4dm1n/api",
  timeout: 10000, // ⏱️ Cancel if request takes more than 10 seconds
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor — Attach token if available
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // or get from Redux store
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor — Handle global API errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server returned an error response (4xx / 5xx)
      if (process.env.NODE_ENV !== "production") {
        console.error(
          `❌ API Error [${error.response.status}]:`,
          error.response.data?.message || error.message
        );
      }

      if (error.response.status === 401) {
        // Handle unauthorized (optional)
        // Example: logout or refresh token
        // localStorage.removeItem("token");
        // window.location.reload();
      }
    } else if (error.request) {
      // No response from server (network or timeout)
      if (process.env.NODE_ENV !== "production") {
        console.warn("⚠️ Network or timeout error:", error.message);
      }
    } else {
      // Axios setup issue
      console.error("Axios setup error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default instance;
